import CommentService from '../services/CommentsService';

export default {
    namespaced: true,
    
    state: {
        customerId: null,
        siteId: null,
        comments: [],
        loading: false,
        loaded: false,
        show_modal: false,
        modal_title: '',
    },

    actions: {
        loadComments({state, commit}) {
            commit('setLoading', true);
            const params = {
                customer_id: state.customerId,
                site_id: state.siteId,
            };
            CommentService.index(params).then(res => {
                commit('setComments', res.data);
                commit('setLoaded', true);
            }).then(() => {
                commit('setLoading', false);
            });
        },

        setupListener({state, dispatch}) {
            window.Echo.channel('comments')
                .listen('CommentSaved', event => {
                    let stateSiteId = state.siteId;
                    if (stateSiteId === '*') {
                        stateSiteId = null;
                    }
                    if (event.comment.site_id === stateSiteId && event.comment.customer_id == state.customerId) {
                        dispatch('loadComments');
                    }
                });
        },

        stopListener() {
            window.Echo.leave('comments');
        },
    },

    mutations: {
        setParams(state, params) {
            state.customerId = params.customerId;
            state.siteId = params.siteId;
        },

        setCustomerId(state, id) {
            state.customerId = id;
        },
        
        setSiteId(state, type) {
            state.siteId = type;
        },

        setComments(state, commments) {
            state.comments = commments;
        },

        setLoading(state, loading) {
            state.loading = loading;
        },

        setLoaded(state, loaded) {
            state.loaded = loaded;
        },

        toggleModal(state) {
            state.show_modal = !state.show_modal;
        },

        showModal(state) {
            state.show_modal = true;
        },

        hideModal(state) {
            state.show_modal = false;
        },

        setModalTitle(state, title) {
            state.modal_title = title;
        },

        reset(state) {
            state.comments = [];
            state.loading = false;
            state.loaded = false;
            state.modal_title = '';
        },
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/store/comments.js